import { get, readable, writable, derived } from 'svelte/store';
export const categories = readable([
    'wszystkie',
    'pojemniki',
    'podesty'
]);
export const currentCategory = writable(get(categories)[0]);
export const products = readable([
    {
        name: 'Karuzela',
        img: 'karuzela.jpg',
        category: 'podesty'
    },
    {
        name: 'Miska Bern 1',
        img: 'miska-bern-1.jpg',
        category: 'pojemniki'
    },
    {
        name: 'Miska Bern 2',
        img: 'miska-bern-2.jpg',
        category: 'pojemniki'
    },
    {
        name: 'Miska Bern 3',
        img: 'miska-bern-3.jpg',
        category: 'pojemniki'
    },
    {
        name: 'Podest Arena',
        img: 'podest-arena.jpg',
        category: 'podesty'
    },
    {
        name: 'Podest czarny 420x280x25mm',
        img: 'podest-czarny-420x280x25mm.jpg',
        category: 'podesty'
    },
    {
        name: 'Podest czarny 420x280x45mm',
        img: 'podest-czarny-420x280x45mm.jpg',
        category: 'podesty'
    },
    {
        name: 'Podest czarny 420x280x65mm',
        img: 'podest-czarny-420x280x65mm.jpg',
        category: 'podesty'
    },
    {
        name: 'Podest 1/4 koła',
        img: 'podest-jedna-czwarta-kola.jpg',
        category: 'podesty'
    },
    {
        name: 'Podest Quadro',
        img: 'podest-quadro.jpg',
        category: 'podesty'
    },
    {
        name: 'Pojemnik czarny 210x210x70mm',
        img: 'pojemnik-czarny-210x210x70mm.jpg',
        category: 'pojemniki'
    },
    {
        name: 'Pojemnik czarny 280x140x40mm',
        img: 'pojemnik-czarny-280x140x40mm.jpg',
        category: 'pojemniki'
    },
    {
        name: 'Pojemnik czarny 280x140x70mm',
        img: 'pojemnik-czarny-280x140x70mm.jpg',
        category: 'pojemniki'
    },
    {
        name: 'Pojemnik czarny 280x210x40mm',
        img: 'pojemnik-czarny-280x210x40mm.jpg',
        category: 'pojemniki'
    },
    {
        name: 'Pojemnik czarny 280x210x70mm',
        img: 'pojemnik-czarny-280x210x70mm.jpg',
        category: 'pojemniki'
    },
    {
        name: 'Pojemnik czarny 420x280x40mm',
        img: 'pojemnik-czarny-420x280x40mm.jpg',
        category: 'pojemniki'
    },
    {
        name: 'Pojemnik czarny 420x280x70mm',
        img: 'pojemnik-czarny-420x280x70mm.jpg',
        category: 'pojemniki'
    },
    {
        name: 'Pojemnik Fala 1',
        img: 'pojemnik-fala-1.jpg',
        category: 'pojemniki'
    },
    {
        name: 'Pojemnik Fala 2',
        img: 'pojemnik-fala-2.jpg',
        category: 'pojemniki'
    },
    {
        name: 'Pojemnik Fala 3',
        img: 'pojemnik-fala-3.jpg',
        category: 'pojemniki'
    },
    {
        name: 'Pojemnik trapezowy 1',
        img: 'pojemnik-trapezowy-1.jpg',
        category: 'pojemniki'
    },
    {
        name: 'Pojemnik trapezowy 2',
        img: 'pojemnik-trapezowy-2.jpg',
        category: 'pojemniki'
    },
    {
        name: 'Pojemnik trapezowy 3',
        img: 'pojemnik-trapezowy-3.jpg',
        category: 'pojemniki'
    },
    {
        name: 'Pojemnik trójkątny 1',
        img: 'pojemnik-trojkatny-1.jpg',
        category: 'pojemniki'
    },
    {
        name: 'Pojemnik trójkątny 2',
        img: 'pojemnik-trojkatny-2.jpg',
        category: 'pojemniki'
    },
    {
        name: 'Pojemnik trójkątny 3',
        img: 'pojemnik-trojkatny-3.jpg',
        category: 'pojemniki'
    },
    {
        name: 'Pojemnik zielony 280x210x70mm',
        img: 'pojemnik-zielony-280x210x70mm.jpg',
        category: 'pojemniki'
    },
    {
        name: 'Pojemnik zielony 420x280x70mm',
        img: 'pojemnik-zielony-420x280x70mm.jpg',
        category: 'pojemniki'
    },
    {
        name: 'Pojemnik żółty 280x210x70mm',
        img: 'pojemnik-zolty-280x210x70mm.jpg',
        category: 'pojemniki'
    },
    {
        name: 'Pojemnik żółty 420x280x70mm',
        img: 'pojemnik-zolty-420x280x70mm.jpg',
        category: 'pojemniki'
    },
    {
        name: 'Taca czarna 280x140x20mm',
        img: 'taca-czarna-280x140x20mm.jpg',
        category: 'pojemniki'
    },
    {
        name: 'Taca czarna 280x210x20mm',
        img: 'taca-czarna-280x210x20mm.jpg',
        category: 'pojemniki'
    },
    {
        name: 'Taca czarna 420x280x20mm',
        img: 'taca-czarna-420x280x20mm.jpg',
        category: 'pojemniki'
    }
]);
export const currentProducts = derived([currentCategory, products], ([$currentCategory, $products]) => {
    if ($currentCategory === get(categories)[0])
        return $products;
    return $products.filter(product => {
        return product.category === $currentCategory;
    });
});
